export default __webpack_public_path__ + "static/KNC-2f2960f68994d3c7e547595395ff498d.png";